import React, { useEffect, useState } from "react";
import "./CheckList.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { beforeVerficationDocuments, verficationFetchSubmitedResponse, verificationUpdate } from "../../../services/checkListService";
import { getAuditLog } from "../../../utils/calculateDaysInMonthUtils";
import { getFileName } from "../../../utils/validations";

const CheckList = () => {

    const navigate = useNavigate();
    const [educationData, setEducationData] = useState([]);
    const [experienceData, setExperienceData] = useState([]);
    const [bankData, setBankData] = useState([]);
    const [idDetailsData, setIdDetailsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [error, setError] = useState(null);
    const [fullname, setFullname] = useState("");
    const [jobPosition, setJobPosition] = useState("");
    const location = useLocation();
    const employeeUniqueId = location.state?.application?.employeeUniqueId||location.state?.application?.personalInformation?.employeeUniqueId;
    const [showMessage, setShowMessage] = useState(null);

    // === Fetch checklist data from API ===
    const fetchCheckList = async () => {
        try {
            //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/documents/${employeeUniqueId}`);
            const response = await beforeVerficationDocuments(employeeUniqueId);

            const { employeeEducation, employeeExperience, bankDetails, employeeIDDetails } = response.data;

            // Normalize Education Data
            const education = (employeeEducation || []).map((item) => ({
                id: item.id,
                type: "Education",
                qualification: item.qualification?.qualificationName || "-",
                fileName: item.certificate,
                fileUrl: item.certificate,
                status: "",
                comment: "",
            }));

            // Normalize Experience Data
            const experience = (employeeExperience || []).map((item) => ({
                id: item.id,
                type: "Experience",
                qualification: item.designationName || "-",
                fileName: item.relievingLetter,
                fileUrl: item.relievingLetter,
                status: "",
                comment: "",
            }));

            // Normalize Bank Details Data
            const bank = bankDetails
                ? [{
                    id: bankDetails.id,
                    type: "Bank Details",
                    qualification: bankDetails.accountType?.accountTypeName || "-",
                    fileName: bankDetails.passbookFileName,
                    fileUrl: bankDetails.passbookFileName,
                    status: "",
                    comment: "",
                }]
                : [];

            // Normalize ID Details Data
            const idDetails = employeeIDDetails
                ? [
                    {
                        id: `${employeeIDDetails.id}-aadhaar`,
                        type: "ID Details",
                        qualification: "Aadhaar Card",
                        fileName: employeeIDDetails.aadhaarFileName,
                        fileUrl: employeeIDDetails.aadhaarFileName,
                        status: "",
                        comment: "",
                        field: "aadhaar",
                    },
                    {
                        id: `${employeeIDDetails.id}-pan`,
                        type: "ID Details",
                        qualification: "PAN Card",
                        fileName: employeeIDDetails.panCardFileName,
                        fileUrl: employeeIDDetails.panCardFileName,
                        status: "",
                        comment: "",
                        field: "pan",
                    },
                    employeeIDDetails.hasUanNumber && {
                        id: `${employeeIDDetails.id}-uan`,
                        type: "ID Details",
                        qualification: "UAN Card",
                        fileName: employeeIDDetails.uanCardFileName,
                        fileUrl: employeeIDDetails.uanCardFileName,
                        status: "",
                        comment: "",
                        field: "uan",
                    },
                    employeeIDDetails.hasEsiNumber && {
                        id: `${employeeIDDetails.id}-esi`,
                        type: "ID Details",
                        qualification: "ESI Card",
                        fileName: employeeIDDetails.esiCardFileName,
                        fileUrl: employeeIDDetails.esiCardFileName,
                        status: "",
                        comment: "",
                        field: "esi",
                    },
                    {
                        id: `${employeeIDDetails.id}-passport`,
                        type: "ID Details",
                        qualification: "Passport Size Photo",
                        fileName: employeeIDDetails.employeepassportSizeFileName,
                        fileUrl: employeeIDDetails.employeepassportSizeFileName,
                        status: "",
                        comment: "",
                        field: "photo",
                    },
                ].filter(Boolean)
                : [];
            setFullname(response.data.fullname || "");
            setJobPosition(response.data.jobPosition || "");

            setEducationData(education);
            setExperienceData(experience);
            setBankData(bank);
            setIdDetailsData(idDetails);
        } catch (err) {
            console.error("Error fetching checklist:", err);
            setError("Failed to fetch checklist");
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchCheckList();
    // }, []);
    const fetchSubmitedResponse = async () => {
        try {
            // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/verification/verification-status/${employeeUniqueId}`);
            // const data = response.data;
            const data = await verficationFetchSubmitedResponse(employeeUniqueId);
            setResponseData(data);

            // === Update education data with verification status ===
            setEducationData(prev =>
                prev.map(doc => {
                    const verifiedDoc = data.educationVerifications?.find(v => v.documentId === doc.id);
                    return verifiedDoc
                        ? {
                            ...doc,
                            status: verifiedDoc.verified ? "APPROVED" : "RESUBMIT",
                            comment: verifiedDoc.comment || "",
                        }
                        : doc;
                })
            );

            // === Update experience data with verification status ===
            setExperienceData(prev =>
                prev.map(doc => {
                    const verifiedDoc = data.experienceVerifications?.find(v => v.documentId === doc.id);
                    return verifiedDoc
                        ? {
                            ...doc,
                            status: verifiedDoc.verified ? "APPROVED" : "RESUBMIT",
                            comment: verifiedDoc.comment || "",
                        }
                        : doc;
                })
            );

            // === Update bank data ===
            setBankData(prev =>
                prev.map(doc => ({
                    ...doc,
                    status: data.bankDetailsVerified ? "APPROVED" : "RESUBMIT",
                    comment: data.bankDetailsComment || "",
                }))
            );

            // === Update ID details ===
            setIdDetailsData(prev =>
                prev.map(doc => {
                    const field = doc.field;
                    const verified = data[`${field}Verified`];
                    const comment = data[`${field}Comment`] || "";
                    return {
                        ...doc,
                        status: verified ? "APPROVED" : "RESUBMIT",
                        comment,
                    };
                })
            );
        } catch (error) {
            console.log("Error fetching verification response:", error);
        }
    };
    useEffect(() => {
        const fetchAllData = async () => {
            await fetchCheckList();         // Load document data
            await fetchSubmitedResponse();  // Then load verification status
        };
        fetchAllData();
    }, []);


    const handleCheckboxChange = (id, status, setDataFunction) => {
        setDataFunction((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, status: row.status === status ? "" : status } : row
            )
        );
    };

    const handleCommentChange = (id, value, setDataFunction) => {
        setDataFunction((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, comment: value } : row
            )
        );
    };

    // const getFileName = (url) => {
    //     if (!url) return "-";
    //     const fileName = url.split("/").pop();
    //     const lastUnderscore = fileName.lastIndexOf("_");
    //     return lastUnderscore !== -1 ? fileName.substring(lastUnderscore + 1) : fileName;
    // };

    const handleSubmit = async () => {

        const fullName = localStorage.getItem("full_name");
        const role = localStorage.getItem("role");
        const employeeId = localStorage.getItem("employeeId");

        const educationVerifications = educationData.map((doc) => ({
            documentId: doc.id,
            verified: doc.status === "APPROVED",
            comment: doc.comment || "",
        }));

        const experienceVerifications = experienceData.map((doc) => ({
            documentId: doc.id,
            verified: doc.status === "APPROVED",
            comment: doc.comment || "",
        }));

        const bankDoc = bankData[0];
        const bankDetailsVerified = bankDoc?.status === "APPROVED";
        const bankDetailsComment = bankDoc?.comment || "";

        // === ID Details ===
        let idDetailsVerified = true;
        const idDetailsPayload = {};
        idDetailsData.forEach((doc) => {
            const verified = doc.status === "APPROVED";
            idDetailsPayload[`${doc.field}Verified`] = verified;
            idDetailsPayload[`${doc.field}Comment`] = doc.comment || "";
            if (!verified) idDetailsVerified = false;
        });

        const payload = {
            employeeUniqueId,
            educationVerifications,
            experienceVerifications,
            idDetailsVerified,
            ...idDetailsPayload,
            bankDetailsVerified,
            bankDetailsComment,
            // auditLog: {
            //     name: fullName,
            //     role,
            //     employeeId,
            // },
            auditLog: getAuditLog(),
        };

        console.log("Submitting payload:", payload);

        try {
            await verificationUpdate(payload);
            setShowMessage("✅ Verification submitted successfully!");
            navigate("/employeeApplications/submitted");
            setTimeout(() => setShowMessage(null), 5000); // hide after 5 sec
        } catch (err) {
            console.error("Error submitting verification:", err);
            setShowMessage("❌ Failed to submit verification");
            setTimeout(() => setShowMessage(null), 5000);
        }

    };
    // === Compute if ALL documents are approved ===
    const allApproved =
        educationData.every(d => d.status === "APPROVED") &&
        // experienceData.every(d => d.status === "APPROVED") &&
        bankData.every(d => d.status === "APPROVED") &&
        idDetailsData.every(d => d.status === "APPROVED");
    const renderTable = (data, setDataFunction, title, customHeader) => (

        <div className="table-section">

            <h3>{title}</h3>

            <div className="table-view-checkList">
                <div className="table-header-checkList">
                    <div>S.No</div>
                    <div>{customHeader || "Document"}</div> {/* 👈 dynamic header here */}
                    <div>File Name</div>
                    <div>File</div>
                    <div>Approve</div>
                    <div>Resubmit</div>
                    <div>Remark</div>
                </div>
                {data.length > 0 ? (
                    data.map((row, index) => {
                        const isExperienceRow = row.type === "Experience";
                        const isFileMissing = !row.fileName || row.fileName === "null" || row.fileName === null;
                        const isCompanyEmpty = !row.qualification || row.qualification === "-";
                        const isFileMissingAndEmptyCompany = isExperienceRow && isFileMissing && isCompanyEmpty;

                        return (
                            <div
                                key={row.id}
                                className={`table-row-checkList ${row.status?.toLowerCase() || ""}`}
                            >
                                <div>{index + 1}</div>
                                <div>{row.qualification || "-"}</div>
                                <div>{getFileName(row.fileName)}</div>
                                <div>
                                    {row.fileUrl ? (
                                        <a
                                            href={
                                                row.fileUrl.startsWith("http")
                                                    ? row.fileUrl
                                                    : `${process.env.REACT_APP_FILE_BASE_URL}/${row.fileUrl}`
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                                <div>
                                    {isFileMissingAndEmptyCompany ? (
                                        "-"
                                    ) : (
                                        <input
                                            type="checkbox"
                                            checked={row.status === "APPROVED"}
                                            onChange={() =>
                                                handleCheckboxChange(row.id, "APPROVED", setDataFunction)
                                            }
                                        />
                                    )}
                                </div>
                                <div>
                                    {isFileMissingAndEmptyCompany ? (
                                        "-"
                                    ) : (
                                        <input
                                            type="checkbox"
                                            checked={row.status === "RESUBMIT"}
                                            onChange={() =>
                                                handleCheckboxChange(row.id, "RESUBMIT", setDataFunction)
                                            }
                                        />
                                    )}
                                </div>
                                {/* <div>
                                    {isFileMissingAndEmptyCompany ? (
                                        "-"
                                    ) : (
                                        <input
                                            type="text"
                                            value={row.comment}
                                            onChange={(e) =>
                                                handleCommentChange(row.id, e.target.value, setDataFunction)
                                            }
                                        />
                                    )}
                                </div> */}
                                <div>
                                    <input
                                        type="text"
                                        value={row.comment || ""}
                                        onChange={(e) =>
                                            handleCommentChange(row.id, e.target.value, setDataFunction)
                                        }
                                    />
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="table-row-checkList">No data available</div>
                )}

            </div>
        </div>
    );



    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    const getOriginalFileName = (fullPath) => {
        if (!fullPath) return "-";
        const fileName = fullPath.split("/").pop();
        const firstHyphenIndex = fileName.search(/-[\d]/);
        if (firstHyphenIndex === -1) return fileName;
        return fileName.slice(0, firstHyphenIndex) + fileName.slice(fileName.lastIndexOf("."));
    };

    return (
        <div className="checklist-container">
            <h2 className="title">Verification Check List</h2>
            <div><span className="emp-details">Employee details:-</span> &nbsp;<span>{employeeUniqueId}&nbsp;-&nbsp;{fullname}&nbsp;-&nbsp;{jobPosition}</span></div>
            {renderTable(educationData, setEducationData, "Education Documents")}
            {renderTable(experienceData, setExperienceData, "Experience Documents")}
            {renderTable(bankData, setBankData, "Bank Details", "Document")}

            {renderTable(idDetailsData, setIdDetailsData, "ID Details")}
            {showMessage && (
                <div className="confirm-overlay">
                    <div className="success-message-popup">
                        {showMessage}
                    </div>
                </div>
            )}
            <div className="bbtttnnsss-verify">
                <button
                    className="submit-btn-verfication"
                    onClick={handleSubmit}
                    disabled={!allApproved}
                    style={{ opacity: allApproved ? 1 : 0.5 }}
                >
                    Submit Verification
                </button>

                <button
                    className="reject-btn-verfication"
                    onClick={handleSubmit}
                    disabled={allApproved}
                    style={{ opacity: !allApproved ? 1 : 0.5 }}
                >
                    Re-Submission
                </button>
            </div>

        </div>

    );
};

export default CheckList;
